import { mockOrders } from "../constants/mockData";

export const pad = (value) => String(value).padStart(2, "0");

export const formatDate = (date) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

export const addMonths = (date, amount) =>
  new Date(date.getFullYear(), date.getMonth() + amount, 1);

export const makeCalendarRange = (monthDate) => {
  const first = new Date(monthDate.getFullYear(), monthDate.getMonth(), 1);
  const last = new Date(monthDate.getFullYear(), monthDate.getMonth() + 1, 0);
  const start = new Date(first);
  start.setDate(first.getDate() - first.getDay());
  const end = new Date(last);
  end.setDate(last.getDate() + (6 - last.getDay()));
  return { first, last, start, end };
};

export const makeCalendarDays = (start, end) => {
  const days = [];
  const cursor = new Date(start);
  while (cursor <= end) {
    days.push(new Date(cursor));
    cursor.setDate(cursor.getDate() + 1);
  }
  return days;
};

export const mockCalendarItems = mockOrders.flatMap((row) => [
  {
    id: `${row.order_line_id}-check`,
    order_id: row.order_id || row.order_line_id,
    order_no: row.order_no,
    customer_name: row.customer_name,
    item_name_snapshot: row.item_name_snapshot,
    event_type: "CHECK",
    event_label: "확인 필요",
    event_date: row.required_start_date || row.requested_due_date,
    risk_level: row.risk_level,
    schedule_status: row.schedule_status,
  },
  {
    id: `${row.order_line_id}-due`,
    order_id: row.order_id || row.order_line_id,
    order_no: row.order_no,
    customer_name: row.customer_name,
    item_name_snapshot: row.item_name_snapshot,
    event_type: "DUE",
    event_label: "납기",
    event_date: row.requested_due_date,
    risk_level: row.risk_level,
    schedule_status: row.schedule_status,
  },
]);

export const groupCalendarItems = (items) => {
  const map = new Map();
  items.forEach((item) => {
    if (!map.has(item.event_date)) map.set(item.event_date, []);
    map.get(item.event_date).push(item);
  });
  return map;
};

